module.exports = "/_next/static/images/0e66a89fd7131c8163eb14ddf412b487-product-information-md-1x.jpg";